import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Track from './Track'

import {
  FiCalendar,
  FiArrowLeft,
  FiPlus,
  FiX
} from 'react-icons/fi'

const Events = () => {
  const navigate = useNavigate()
  const [ isFormOpen, setIsFormOpen ] = useState( false )

  const back = () => {
    navigate( '/main' )
  }

  const toggleForm = () => {
    setIsFormOpen( ! isFormOpen )
  }

  return <div className="scroll one hs">

    <div className="bar">
      <div className="icon">
        <FiCalendar />
      </div>

      <h1>events</h1>

      <button
        onClick={ toggleForm }
        title="new event"
      >
        <FiPlus />
      </button>

    </div>

    <div className="scroll one hs in-air-2x">

      <ul className="list-menu">
        <li className="list-item">

          <span className="one text">
            union roller 2026
          </span>

          <span className="one text ta-right">
            jun 22, 2026
          </span>

          <span className="icon">
            <FiCalendar />
          </span>
        </li>
      </ul>

    </div>

    <div className="bar">

      <button
        onClick={ back }
      >
        <FiArrowLeft />
      </button>

    </div>

    { /* FORM */ }

    { isFormOpen ? <div className="scroll modal full hs">

      <div className="bar">

        <h1>new event</h1>

        <button
          onClick={ toggleForm }
          title="cancel"
        >
          <FiX />
        </button>
      </div>

      <div className="scroll one hs in-air-2x">
        <form className="gap-2x">

          <div className="form-field">

            <label>name</label>

            <div className="form-control">
              <input
                name="name"
                placeholder="name"
                size={ 1 }
                required
              />
            </div>

          </div>

          <div className="vs gap-2x">

            <div className="one form-field">

              <label>start</label>

              <div className="one form-control">

                <input
                  type="date"
                  name="start"
                  placeholder="starts at"
                  size={ 1 }
                  required
                />

              </div>
            </div>

            <div className="one form-field">

              <label>end</label>

              <div className="one form-control">

                <input
                  type="date"
                  name="end"
                  placeholder="ends at"
                  size={ 1 }
                />

              </div>
            </div>

          </div>

          <div className="bar">
            <h1>tracks</h1>

            <button
              type="button"
              title="add track"
            >
              <FiPlus />
            </button>
          </div>

          { /* name, at, level, head, tail */ }

          <Track />
        </form>
      </div>

    </div> : null }

  </div>
}

export default Events
